export default Object.freeze({
    ARTIFICIAL_REASON: 'ArtificialReason',
    ASSAN: 'Assan',
    EVENTRAC: 'Eventrac',
});



// WEBPACK FOOTER //
// ./src/Assets/components/TenantConfigurations/consts/themes.js